import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerLicense } from '@syncfusion/ej2-base';
import { environment } from './environments/environment';
import App from './App.tsx';

if (environment.SyncfusionLicenseKey) registerLicense(environment.SyncfusionLicenseKey);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
